var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "login-container bgImg content"
  }, [_c("div", {
    staticClass: "layout"
  }, [_c("a-form-model", {
    ref: "loginForm",
    staticClass: "form-container",
    attrs: {
      model: _vm.loginForm,
      rules: _vm.loginRules,
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("Insurforce")]), _c("a-tabs", {
    staticClass: "tabs",
    attrs: {
      tabBarGutter: 5
    },
    model: {
      value: _vm.currentTab,
      callback: function ($$v) {
        _vm.currentTab = $$v;
      },
      expression: "currentTab"
    }
  }, [_c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("账号密码登录")
    }
  }, [_vm.currentTab === "2" ? _c("a-form-model-item", {
    attrs: {
      prop: "account"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("账号"),
      size: "large",
      "allow-clear": "",
      type: "text"
    },
    model: {
      value: _vm.loginForm.account,
      callback: function ($$v) {
        _vm.$set(_vm.loginForm, "account", $$v);
      },
      expression: "loginForm.account"
    }
  }, [_c("svg-icon", {
    attrs: {
      slot: "prefix",
      icon: "phone",
      size: 14
    },
    slot: "prefix"
  })], 1)], 1) : _vm._e(), _vm.currentTab === "2" ? _c("a-form-model-item", {
    attrs: {
      prop: "password"
    }
  }, [_c("a-input-password", {
    ref: "password",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("密码"),
      size: "large",
      "allow-clear": "",
      maxLength: 30
    },
    on: {
      pressEnter: _vm.toLogin
    },
    model: {
      value: _vm.loginForm.password,
      callback: function ($$v) {
        _vm.$set(_vm.loginForm, "password", $$v);
      },
      expression: "loginForm.password"
    }
  }, [_c("svg-icon", {
    attrs: {
      slot: "prefix",
      icon: "password",
      size: 14
    },
    slot: "prefix"
  })], 1)], 1) : _vm._e()], 1), _c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("手机号登录")
    }
  }, [_vm.currentTab === "1" ? _c("a-form-model-item", {
    attrs: {
      prop: "phone"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("手机号"),
      size: "large",
      "allow-clear": "",
      maxLength: 11,
      type: "text"
    },
    scopedSlots: _vm._u([{
      key: "addonBefore",
      fn: function () {
        return [_c("a-select", {
          staticStyle: {
            width: "90px"
          },
          attrs: {
            dropdownClassName: "mul-select-dropdown",
            dropdownMenuStyle: {
              width: "180px"
            },
            "option-label-prop": "value"
          },
          on: {
            change: _vm.changeGlobalRoaming
          },
          model: {
            value: _vm.loginForm.globalRoaming,
            callback: function ($$v) {
              _vm.$set(_vm.loginForm, "globalRoaming", $$v);
            },
            expression: "loginForm.globalRoaming"
          }
        }, _vm._l(_vm.globalRoamingOptionData, function (item) {
          return _c("a-select-option", {
            key: item.label,
            attrs: {
              value: item.label
            }
          }, [_c("span", {
            attrs: {
              title: item.label + _vm.$t(item.value)
            }
          }, [_vm._v(_vm._s(item.label) + "  " + _vm._s(_vm.$t(item.value)))])]);
        }), 1)];
      },
      proxy: true
    }], null, false, 2578560947),
    model: {
      value: _vm.loginForm.phone,
      callback: function ($$v) {
        _vm.$set(_vm.loginForm, "phone", $$v);
      },
      expression: "loginForm.phone"
    }
  })], 1) : _vm._e(), _vm.currentTab === "1" ? _c("a-form-model-item", {
    attrs: {
      prop: "code"
    }
  }, [_c("a-input", {
    ref: "code",
    staticStyle: {
      width: "53%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("验证码"),
      size: "large",
      maxLength: 6
    },
    on: {
      pressEnter: _vm.toLogin
    },
    model: {
      value: _vm.loginForm.code,
      callback: function ($$v) {
        _vm.$set(_vm.loginForm, "code", $$v);
      },
      expression: "loginForm.code"
    }
  }), _c("a-button", {
    staticStyle: {
      "margin-left": "7%",
      width: "40%"
    },
    attrs: {
      size: "large",
      title: _vm.$t(_vm.phoneCode),
      disabled: _vm.codeStatus
    },
    on: {
      click: _vm.getCode
    }
  }, [_c("span", {
    staticClass: "phone-code"
  }, [_vm._v(_vm._s(_vm.$t(_vm.phoneCode)))])])], 1) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "loginTips"
  }, [_vm._v(_vm._s(_vm.$t("登录视为您已同意使用协议、隐私政策")))]), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      block: "",
      size: "large"
    },
    on: {
      click: _vm.toLogin
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("登录")) + " ")]), _c("nav-locale", {
    staticClass: "mul-icon-class pointer boxHover flex-sub",
    attrs: {
      islogin: true
    }
  })], 1)], 1)], 1), _c("div", {
    staticClass: "bottomBarBox"
  }, [_c("span", {
    on: {
      click: function ($event) {
        return _vm.jumpArticlePage("3");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("使用协议")))]), _vm._v(" | "), _c("span", {
    on: {
      click: function ($event) {
        return _vm.jumpArticlePage("4");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("隐私政策")))]), _vm._v(" | "), _c("span", {
    on: {
      click: _vm.cookieManageCli
    }
  }, [_vm._v(_vm._s(_vm.$t("cookie管理")))])]), !_vm.personalSet && _vm.personalSet === null && _vm.cookieConfig !== undefined && _vm.cookieConfig !== null ? _c("div", {
    staticClass: "cookieContBox",
    style: [{
      height: _vm.cookieBoxVisible ? "100%" : "0"
    }, {
      transition: _vm.cookieBoxVisible ? "all 0.5s" : "all 0"
    }]
  }, [_vm.cookieBoxVisible ? _c("div", {
    staticClass: "mask"
  }) : _vm._e(), _c("div", {
    staticClass: "transitionBox",
    style: [{
      height: _vm.cookieBoxVisible ? "200px" : "0"
    }, {
      transition: _vm.cookieBoxVisible ? "height 0.5s" : "all 0"
    }]
  }, [_c("div", {
    staticClass: "cookieContent"
  }, [_c("div", {
    staticClass: "cookieCont",
    domProps: {
      innerHTML: _vm._s(_vm.cookieConfig.fileContent)
    }
  }), _c("div", {
    staticClass: "handleBox"
  }, [_c("a-button", {
    staticClass: "agree",
    attrs: {
      type: "primary",
      size: "large"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.allowHandle.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("我接受")) + " ")]), _c("a-button", {
    staticClass: "link",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.personalSetCli.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("个性化设置")) + " ")])], 1)])])]) : _vm._e(), _vm.cookieConfig !== undefined && _vm.cookieConfig !== null ? _c("a-modal", {
    attrs: {
      closable: false,
      maskClosable: false,
      footer: null,
      width: 600
    },
    model: {
      value: _vm.cookieModelVisible,
      callback: function ($$v) {
        _vm.cookieModelVisible = $$v;
      },
      expression: "cookieModelVisible"
    }
  }, [_c("div", {
    staticClass: "cookieMadalCont"
  }, [_c("div", {
    staticClass: "cookieModelCont",
    domProps: {
      innerHTML: _vm._s(_vm.cookieConfig.content)
    }
  }), _c("div", {
    staticClass: "setBox"
  }, [_c("span", {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.$t("个性化设置")))]), _c("a-button", {
    staticClass: "agree",
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.allowHandle
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("全部允许")) + " ")])], 1), _c("ul", {
    staticClass: "cookieSetList"
  }, [_c("div", [_c("li", [_c("span", [_vm._v(_vm._s(_vm.locale === "en_US" ? _vm.en.基础设置标题 : _vm.$t("基础设置")))]), _c("span", {
    staticClass: "handleTit"
  }, [_vm._v(_vm._s(_vm.$t("始终处于活动状态")))])]), _c("span", {
    staticClass: "itemContent"
  }, [_vm._v(" " + _vm._s(_vm.locale === "en_US" ? _vm.en.基础设置内容 : _vm.$t("基本cookies对于提供我们的网站和服务是必要的，并且不能被停用。它们通常是根据您在网站上的操作而设置的，例如设置您的隐私首选项、登录或填写表格。")) + " ")])]), _c("div", [_c("li", [_c("span", [_vm._v(_vm._s(_vm.locale === "en_US" ? _vm.en.性能标题 : _vm.$t("性能")))]), _c("span", {
    staticClass: "handle"
  }, [_c("a-switch", {
    attrs: {
      checked: _vm.switchOne
    },
    on: {
      change: function ($event) {
        return _vm.switchChange("switchOne", $event);
      }
    }
  })], 1)]), _c("span", {
    staticClass: "itemContent"
  }, [_vm._v(" " + _vm._s(_vm.locale === "en_US" ? _vm.en.性能内容 : _vm.$t("性能cookies提供有关客户如何浏览我们网站的匿名统计数据，以便我们改善网站体验和性能。经批准的第三方可以代表我们执行分析，但他们不能将数据用于自己的目的。")) + " ")])]), _c("div", [_c("li", [_c("span", [_vm._v(_vm._s(_vm.locale === "en_US" ? _vm.en.功能标题 : _vm.$t("功能")))]), _c("span", {
    staticClass: "handle"
  }, [_c("a-switch", {
    attrs: {
      checked: _vm.switchTwo
    },
    on: {
      change: function ($event) {
        return _vm.switchChange("switchTwo", $event);
      }
    }
  })], 1)]), _c("span", {
    staticClass: "itemContent"
  }, [_vm._v(" " + _vm._s(_vm.locale === "en_US" ? _vm.en.功能内容 : _vm.$t("功能性cookies帮助我们提供有用的网站功能、记住您的偏好并显示相关内容。经批准的第三方可能会设置这些cookie以提供某些网站功能。如果您不允许这些cookie，那么这些服务中的一部分或全部可能无法正常工作。")) + " ")])]), _c("div", [_c("li", [_c("span", [_vm._v(_vm._s(_vm.locale === "en_US" ? _vm.en.广告标题 : _vm.$t("广告")))]), _c("span", {
    staticClass: "handle"
  }, [_c("a-switch", {
    attrs: {
      checked: _vm.switchThree
    },
    on: {
      change: function ($event) {
        return _vm.switchChange("switchThree", $event);
      }
    }
  })], 1)]), _c("span", {
    staticClass: "itemContent"
  }, [_vm._v(" " + _vm._s(_vm.locale === "en_US" ? _vm.en.广告内容 : _vm.$t("广告cookies可以由我们或我们的广告合作伙伴通过我们的网站设置，并帮助我们提供相关的营销内容。如果您不允许这些cookies，您将体验到较少的相关广告。")) + " ")])])])]), _c("div", {
    staticClass: "saveBox"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.savePersonalSet
    }
  }, [_vm._v(_vm._s(_vm.$t("保存我的设置")))])], 1)]) : _vm._e(), _vm.loginErrorVisible ? _c("loginErrorModal", {
    attrs: {
      loginErrorVisible: _vm.loginErrorVisible,
      contactWay: _vm.contactWay,
      cancellationTime: _vm.cancellationTime
    },
    on: {
      "update:loginErrorVisible": function ($event) {
        _vm.loginErrorVisible = $event;
      },
      "update:login-error-visible": function ($event) {
        _vm.loginErrorVisible = $event;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };